$(function () {
	var tag = document.createElement('script');
	tag.src = "https://www.youtube.com/iframe_api";
	var firstScriptTag = document.getElementsByTagName('script')[0];
	firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
	
	
	var ytPlayer = [];
	var ytData = [
		{
			id: 'K_dMNU70AhI', //youtubeのID
			area: 'youtubeVideo0', //youtubeを表示する場所
		},
		{
			id: 'jFMyNGEoiXQ',
			area: 'youtubeVideo1',
		},
		{
			id: 'xaShF0WWTPw',
			area: 'youtubeVideo2',
		},
		{
			id: 'fQpiNBG5KQI',
			area: 'youtubeVideo3',
		},
	];
	
	
	window.onYouTubeIframeAPIReady = function() {
		for (var i = 0; i < ytData.length; i++) {
			ytPlayer[i] = new YT.Player(ytData[i]['area'], {
				width: '100%',
				height: '100%',
				videoId: ytData[i]['id'],
				loop: 1,
				rel: 0,
				modestbranding: 1,
				frameborder:0,
				iv_load_policy: 3,
				showinfo:0,
			});
		}
	}
});	


$(function () {
 
	/**
	 * 都道府県モーダル
	 */
	$('.pg-p-search-store').find('.pg-p-search-store__ul').find('.pg-p-search-store__li').find('a').on('click',function(){
		let areaId = $(this).data('areaid');
		$.ajax({
		url: '/api/area/index?area_id='+areaId,
		type: 'GET',
		dataType: 'json',
		}).done(function(data) {
			$('.pg-p-search-store-modal').fadeIn();
			$('.pg-p-search-store-modal').find('.pg-p-search-store-modal-content').find('li').remove();
			let list = '';
			for(let i in data['area']) {
				let area = data['area'][i]['area_name']
				let areaId = data['area'][i]['id']

				list += '<li><a href="'+data['url'][areaId]+'" target="_blank"><img src="/images/common/icon_house.svg">'+ area+'</a></li>';

			}
			$('.pg-p-search-store-modal').find('.pg-p-search-store-modal-content').find('ul').append(list);
		}).fail(function( jqXHR, textStatus, errorThrown) {
		});
        });
	$('.pg-p-search-store-rental').find('.pg-p-search-store__ul').find('.pg-p-search-store__li').find('a').on('click',function(){
		let areaId = $(this).data('areaid');
		$.ajax({
		url: '/api/area/index?area_id='+areaId+'&service=rental_space',
		type: 'GET',
		dataType: 'json',
		}).done(function(data) {
			$('.pg-p-search-store-rental-modal').fadeIn();
			$('.pg-p-search-store-rental-modal').find('.pg-p-search-store-modal-content').find('li').remove();
			let list = '';
			for(let i in data['area']) {
				let area = data['area'][i]['area_name']
				let areaId = data['area'][i]['id']
				
				list += '<li><a href="'+data['url'][areaId]+'" target="_blank"><img src="/images/common/icon_house.svg">'+ area+'</a></li>';
					
			}
			$('.pg-p-search-store-rental-modal').find('.pg-p-search-store-modal-content').find('ul').append(list);
		}).fail(function( jqXHR, textStatus, errorThrown) {
		});
    });
	$('.pg-p-search-store-trunk').find('.pg-p-search-store__ul').find('.pg-p-search-store__li').find('a').on('click',function(){
		let areaId = $(this).data('areaid');
		$.ajax({
		url: '/api/area/index?area_id='+areaId+'&service=monokura',
		type: 'GET',
		dataType: 'json',
		}).done(function(data) {
			$('.pg-p-search-store-trunk-modal').fadeIn();
			$('.pg-p-search-store-trunk-modal').find('.pg-p-search-store-modal-content').find('li').remove();
			let list = '';
			for(let i in data['area']) {
				let area = data['area'][i]['area_name']
				let areaId = data['area'][i]['id']
				
				list += '<li><a href="'+data['url'][areaId]+'" target="_blank"><img src="/images/common/icon_house.svg">'+ area+'</a></li>';
					
			}
			$('.pg-p-search-store-trunk-modal').find('.pg-p-search-store-modal-content').find('ul').append(list);
		}).fail(function( jqXHR, textStatus, errorThrown) {
		});
    });
	$('.pg-p-search-store-modal').find('.pg-p-search-store-modal-back').on('click',function(){
		$('.pg-p-search-store-modal').fadeOut();
        return false;
    });
	$('.pg-p-search-store-modal').find('span').on('click',function(){
		$('.pg-p-search-store-modal').fadeOut();
        return false;
    });

	$('.pg-p-page-link a[href*="#"]').click(function () {
	  var elmHash = $(this).attr('href'); //ページ内リンクのHTMLタグhrefから、リンクされているエリアidの値を取得
	  var pos = $(elmHash).offset().top;  //idの上部の距離を取得
	  $('body,html').animate({scrollTop: pos}, 500); //取得した位置にスクロール。500の数値が大きくなるほどゆっくりスクロール
	  return false;
	});
	
	
	$('.pg-p-storage-example').find('li').on('click',function(){
		var type = $(this).find('img').data('type');
		if(type == 1){
			var img = '<img src="/images/scene/reform_s02.jpg" class="img-responsive" width="100%" alt="">'
		}
		if(type == 2){
			var img = '<img src="/images/scene/reform_m02.jpg" class="img-responsive" width="100%" alt="">'
		}
		if(type == 3){
			var img = '<img src="/images/scene/reform_l02.jpg" class="img-responsive" width="100%" alt="">'
		}
		if(type == 4){
			var img = '<img src="/images/scene/reform_lh02.jpg" class="img-responsive" width="100%" alt="">'
		}
		if(type == 5){
			var img = '<img src="/images/scene/private/otokura_size-02.svg" class="img-responsive" width="100%" alt="">'
		}
		$('.pg-p-storage-example__modal').find('.pg-p-storage-example__modal-content').find('img').remove();
		$('.pg-p-storage-example__modal').find('.pg-p-storage-example__modal-content').prepend(img);
		$('.pg-p-storage-example__modal').fadeIn();
		
		
        return false;
    });
	$('.pg-p-storage-example__modal').find('.background').on('click',function(){
		$('.pg-p-storage-example__modal').fadeOut();
        return false;
    });
	$('.pg-p-storage-example__modal').find('p').on('click',function(){
		$('.pg-p-storage-example__modal').fadeOut();
        return false;
    });
	
});
